import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterStatutProfessionnelByNamePipe } from 'src/app/shared/pipes/filter-statutProfessionnel-by-name/filter-statutProfessionnel-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { StatutProfessionnelModalDetailComponent } from './modal/statutProfessionnel-modal-detail/statutProfessionnel-modal-detail.component';
import { StatutProfessionnelModalAjoutComponent } from './modal/statutProfessionnel-modal-ajout/statutProfessionnel-modal-ajout.component';
import { ListStatutProfessionnelComponent } from './list-statutProfessionnel/list-statutProfessionnel.component';

@NgModule({
	declarations: [
		ListStatutProfessionnelComponent,
		StatutProfessionnelModalDetailComponent,
		StatutProfessionnelModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterStatutProfessionnelByNamePipe]
})

export class StatutProfessionnelModule {}
